module.exports = __webpack_public_path__ + "img/category-temporal.c60e0fa9.svg";